export const urlcampaign = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/campaign`
export const urlpresents = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/presents`
export const urlUser = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/user`
export const urluserpresentGetItem = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/user/present`
export const urluserpresentsItem = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/user/presents`
export const urlregister = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/register`
export const urllogin = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/login`
export const urlrefresh = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/refresh`
export const urlspots = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/spots`
export const urlusersheets = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/user/sheets`
export const urlsheets = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/sheets`
export const urlstamps = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/stamps`
export const urlcoupons = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/coupons`
export const urldelstamps = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/user/stamps`
export const urlnotifications = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/notifications`
export const urlquestionnairesanswer = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/questionnaires/answer/type`
export const urlquestionnairestype = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/questionnaires/type`
export const urlinquiry = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/inquiry`
export const urlmenu = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/menus`
export const urlphotos = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/photos`
export const urlphoto = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/photo`
export const urlphotocheck = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/photo/check`
export const authcheck = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/auth/check`
export const urlpointhistory = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/point_history`
export const urlTracking = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/tracking`
